import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Home Page", -1)
const _hoisted_3 = { key: 0 }

import { DataModel } from '@/models/data.model';
import { StatsModel } from '@/models/stats.model';
import { CacheService } from '@/services/cache.service';
import { onBeforeMount, onBeforeUnmount, ref } from 'vue';
import PlayerTable from "@/components/PlayerTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const data = ref<DataModel[]>();
const stats = ref<StatsModel>();

function loadData() {
  CacheService.retrieveAll()
    .then(rsp => data.value = rsp.data)
  CacheService.retrieveStats()
    .then(rsp => stats.value = rsp.data)
}

// retrieve data on mount
onBeforeMount(() => loadData())

// auto update data every 15 sec
const interval = setInterval(loadData, 15000)
onBeforeUnmount(() => clearInterval(interval));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (stats.value)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "Displaying total of " + _toDisplayString(stats.value.count) + " players from " + _toDisplayString(stats.value.guilds.count) + " different guilds", 1))
      : _createCommentVNode("", true),
    (data.value)
      ? (_openBlock(), _createBlock(PlayerTable, {
          key: 1,
          players: data.value,
          "load-data": loadData
        }, null, 8, ["players"]))
      : _createCommentVNode("", true)
  ]))
}
}

})